<template>
  <div class="container pd-t-50 pd-b-30">
    <div style="color: white" class="text-center">
      Засгийн газрын Хэрэг эрхлэх газар, Дэлхийн банкны санхүүжилтээр
      <br />"Ухаалаг засаг" төслийн хүрээнд энэхүү Цахим сургалтын платформыг
      нэвтрүүлэв.
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
